const resizeAxis = (chart) => {
  const SUB_YAXIS_HEIGHT = 20
  const mainYAxis = chart.get('main-yaxis')
  const volumeYAxis = chart.get('volume-yaxis')

  let visibleYAxis = []

  if (volumeYAxis.visible) {
    visibleYAxis.push(volumeYAxis)
  }

  const mainHeight = 100 - visibleYAxis.length * SUB_YAXIS_HEIGHT

  mainYAxis.update(
    {
      height: `${mainHeight}%`,
    },
    false
  )

  visibleYAxis.forEach((vYAxis, i) => {
    vYAxis.update(
      {
        top: `${mainHeight + i * SUB_YAXIS_HEIGHT}%`,
      },
      false
    )
  })

  chart.render()
}

export default resizeAxis
